import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AuthGuardService as AuthGuard
} from './common/services/auth-guard.service';
import { PageNotFoundComponent } from './pages/public/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'pageNotFound', component: PageNotFoundComponent,
  },
  { path: '', loadChildren: () => import('./pages/public/login/login.module').then(m => m.LoginModule) },
  { path: 'secure/account', canActivate: [AuthGuard], loadChildren: () => import('./pages/secure/account/account.module').then(m => m.AccountModule) },
  { path: 'secure/dashboard', canActivate: [AuthGuard], loadChildren: () => import('./pages/secure/dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'forgot-password', loadChildren: () => import('./pages/public/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
  { path: 'login', loadChildren: () => import('./pages/public/login/login.module').then(m => m.LoginModule) },
  { path: 'login-okta', loadChildren: () => import('./pages/public/login-okta/login-okta.module').then(m => m.LoginOktaModule) },
  { path: 'secure/reports', canActivate: [AuthGuard], loadChildren: () => import('./pages/secure/reports/reports.module').then(m => m.ReportsModule) },
  { path: 'reset-password', loadChildren: () => import('./pages/public/reset-password/reset-password.module').then(m => m.ResetPasswordModule) },
  { path: 'secure/students', canActivate: [AuthGuard], loadChildren: () => import('./pages/secure/students/students.module').then(m => m.StudentsModule) },
  { path: 'secure/special-enrollments', canActivate: [AuthGuard], loadChildren: () =>
  import('./pages/secure/special-enrollments/special-enrollments.module').then(m => m.SpecialEnrollmentsModule) },
  { path: '**', redirectTo: 'pageNotFound', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
